/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * NPI enumeration type. NPI-1 = individual/physician, NPI-2 = organization/facility
 * @export
 */
export const NpiResponseEnumerationType = {
    Npi1: 'NPI-1',
    Npi2: 'NPI-2',
} as const;
export type NpiResponseEnumerationType = typeof NpiResponseEnumerationType[keyof typeof NpiResponseEnumerationType];


export function instanceOfNpiResponseEnumerationType(value: any): boolean {
    for (const key in NpiResponseEnumerationType) {
        if (Object.prototype.hasOwnProperty.call(NpiResponseEnumerationType, key)) {
            if (NpiResponseEnumerationType[key as keyof typeof NpiResponseEnumerationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NpiResponseEnumerationTypeFromJSON(json: any): NpiResponseEnumerationType {
    return NpiResponseEnumerationTypeFromJSONTyped(json, false);
}

export function NpiResponseEnumerationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NpiResponseEnumerationType {
    return json as NpiResponseEnumerationType;
}

export function NpiResponseEnumerationTypeToJSON(value?: NpiResponseEnumerationType | null): any {
    return value as any;
}

export function NpiResponseEnumerationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NpiResponseEnumerationType {
    return value as NpiResponseEnumerationType;
}

